export { default } from './StatusTitle';
